function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("path", {
  d: "M11.934 0c6.062 0 11 4.938 11 11s-4.938 11-11 11-11-4.938-11-11 4.938-11 11-11zm0 .936C6.387.936 1.87 5.453 1.87 11s4.517 10.064 10.064 10.064S21.998 16.547 21.998 11 17.48.936 11.934.936zm.328 6.202L16.123 11l-3.861 3.862-.656-.656 2.738-2.738H8.4v-.936l5.943-.001-2.737-2.737.656-.656z",
  fillRule: "nonzero"
});

function SvgPrimaryInlineRight(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 23 22",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _ref);
}

export default SvgPrimaryInlineRight;